module.exports = __webpack_public_path__ + "img/setting.77737b28.png";